import { antdMessageError, antdMessageInfo } from "./Utils";

export const ruleCarrying = ({ order_type, delivery }) => {
  if (order_type == "dpd") return true;
  if (order_type === "lp_express" && delivery == "lp_express_home") return true;
  if (order_type === "venipak" && delivery == "venipak_home") return true;
  if (order_type === "posti" && delivery == "posti_home") return true;
  if (order_type === "itella" && delivery == "itella_home") return true;
  if (order_type === "matkahuolto" && delivery == "matkahuolto_home")
    return true;
  return false;
};

export const validPostiConnect = ({ order_type, delivery, weight }) => {
  if (order_type !== "posti") return false;
  if (delivery !== "posti_home") return false;
  // if ((+weight || 0) < 25) return false;
  return true;
};

export const validCreatingShipment = (shipment, id_order = null) => {
  const {
    shipment_additional_services_attributes,
    shipment_address_attributes,
  } = shipment;
  // const { shipment_additional_services_attributes } = shipment
  let errors = {};
  let warnings = {};
  const delivery = shipment_additional_services_attributes.find(
    (attribute) => attribute.service_key == "delivery"
  )?.service_value;

  const delivery_same_day = shipment_additional_services_attributes.find(
    (attribute) =>
      attribute.service_key == "delivery_same_day" && !!attribute.service_value
  );
  const cod = shipment_additional_services_attributes.find(
    (attribute) =>
      attribute.service_key == "cod" && attribute.service_value !== null
  );
  if (delivery_same_day && cod) {
    errors["delivery_same_day_cod"] =
      "[Same day delivery + COD]: Choose another payment method or courier.";
  }

  // const recycle = shipment_additional_services_attributes.find((attribute) => attribute.service_key == "recycle" && !!attribute.service_value)
  // const connect = shipment_additional_services_attributes.find((attribute) => attribute.service_key == "connect" && !!attribute.service_value)

  // if ((recycle || connect) && +weight < 25) {
  //   if (recycle) {
  //     errors['recycle'] = '[Recycle]: Minimum weight must be 25.'
  //   }
  //   if (connect) {
  //     errors['connect'] = '[Connect]: Minimum weight must be 25.'
  //   }
  // }

  const itsBulkShipment = shipment_additional_services_attributes.find(
    (attribute) =>
      attribute.service_key == "created_through" &&
      attribute.service_value == "bulk_action"
  );

  if (
    !itsBulkShipment &&
    !shipment_address_attributes.parcel_terminal_id &&
    delivery &&
    delivery.includes("_postMachine")
  ) {
    errors["parcel_terminal_id"] = "Select the parcel terminal";
  }

  if (itsBulkShipment) {
    const isParcelTerminal = delivery && delivery.includes("_postMachine");

    if (
      !isParcelTerminal &&
      (!shipment_address_attributes.address ||
        !shipment_address_attributes.address.trim())
    ) {
      warnings["address"] = `Order created without street address`;
    }
  }

  const isValid = Object.keys(errors).length === 0;
  if (!isValid) {
    Object.entries(errors).forEach(([_, value]) => {
      if (!!id_order && !!value && !value.startsWith(`[${id_order}]`)) {
        return antdMessageError(`[${id_order}]: ${value}`);
      }
      antdMessageError(value);
    });
  }

  if (Object.keys(warnings).length > 0) {
    Object.entries(warnings).forEach(([_, value]) => {
      const message = id_order ? `[${id_order}]: ${value}` : value;
      console.warn(message);
      antdMessageInfo(message);
    });
  }

  return {
    errors,
    warnings,
    isValid,
  };
};

export const shipmentTypeRules = (order_type) => {
  const home_delivery = "Home delivery";
  const post_machine = "Delivery to the post machine";

  const deliveryMethods = {
    dpd: {
      deliveries: [
        { value: "dpd_b2c", label: "B2C shipment (for private person)" },
        {
          label: post_machine,
          value: "dpd_postMachine",
        },
      ],
    },
    omniva: {
      deliveries: [
        {
          label: home_delivery,
          value: "omniva_home",
        },
        {
          label: post_machine,
          value: "omniva_postMachine",
        },
      ],
    },
    lp_express: {
      deliveries: [
        {
          label: home_delivery,
          value: "lp_express_home",
        },
        {
          label: post_machine,
          value: "lp_express_postMachine",
        },
      ],
    },
    venipak: {
      deliveries: [
        {
          label: home_delivery,
          value: "venipak_home",
        },
        {
          label: post_machine,
          value: "venipak_postMachine",
        },
      ],
    },
    posti: {
      deliveries: [
        {
          label: home_delivery,
          value: "posti_home",
        },
        {
          label: post_machine,
          value: "posti_postMachine",
        },
      ],
    },
    itella: {
      deliveries: [
        {
          label: home_delivery,
          value: "itella_home",
        },
        {
          label: post_machine,
          value: "itella_postMachine",
        },
      ],
    },
    matkahuolto: {
      deliveries: [
        {
          label: home_delivery,
          value: "matkahuolto_home",
        },
        {
          label: post_machine,
          value: "matkahuolto_postMachine",
        },
      ],
    },
    zipasgo: {
      deliveries: [
        {
          label: home_delivery,
          value: "zipasgo_home",
        },
        {
          label: post_machine,
          value: "zipasgo_postMachine",
        },
      ],
    },
    at_the_store: {
      deliveries: [
        {
          label: "LP express",
          value: "lp_express",
        },
        {
          label: "DPD",
          value: "dpd",
        },
        {
          label: "Venipak",
          value: "venipak",
        },
      ],
    },
  };

  const selectedMethod = deliveryMethods[order_type];

  return selectedMethod ? selectedMethod : { deliveries: [] };
};
